import memoize from 'lodash/memoize';
import axios from 'axios';
/* istanbul ignore file */

export function formatLocaleData({ applicationResource, locale }) {
  const localeData = {};

  applicationResource.forEach((localePair) => {
    /** @description Object.assign() froze the browser */
    localeData[localePair.key] = localePair.value;
  });

  return { locale, localeData };
}

// eslint-disable-next-line no-unused-vars
export const fetchAllResource = memoize((locale = 'en_US') => {
  if (process.env.NODE_ENV === 'production') return Promise.resolve();

  return Promise.resolve();
  // Uncomment when we actually implement this
  // return axios
  //   .get(`/banking-services/localizationService/getAllResources/${locale}`)
  //   .then(({ data: { data } }) => data)
  //   .then(data => formatLocaleData(data));
});

export const fetchLoginResource = memoize((locale = 'en_US') => {
  if (process.env.NODE_ENV === 'production') return Promise.resolve();
  return axios
    .post(`/banking-services/localizationService/getLoginResources/${locale}`)
    .then(({ data: { data } }) => data)
    .then((data) => formatLocaleData(data));
});
